import PropTypes from 'prop-types';
import { instanceToPlain, plainToInstance } from 'class-transformer';
// project import
import FormStepper from 'components/form-stepper/FormStepper';
import { TypeMode } from 'constants/TypeMode';
import { useDispatch } from 'react-redux';
import StandardModalForm from 'components/shared/StandardModalForm';
import { updateMissionSuccess } from 'store/actions/missions';
import { modifyDataMission } from 'services/mission/MissionService';

// eslint-disable-next-line react/prop-types
const EditTitleMission = ({
    service,
    config,
    entity,
    defaultValue,
    open,
    onClose,
    title,
    maxWidth,
}) => {
    const dispatch = useDispatch();

    const handleOnClose = action => {
        onClose(action);
    };

    const handleOnSubmit = async (data, successCallback, errorCallback) => {
        const postData = plainToInstance(entity, data);
        try {
            const response = await service.update(postData);
            dispatch(updateMissionSuccess(modifyDataMission(response)));
            successCallback('Data saved');
        } catch (err) {
            errorCallback(err, 'An error occurred');
        }
    };

    return (
        <StandardModalForm
            mode={TypeMode.Edit}
            formConfig={config}
            defaultValue={instanceToPlain(defaultValue)}
            onClose={handleOnClose}
            onSubmit={handleOnSubmit}
            open={open}
            title={title}
            maxWidth={maxWidth}
        >
            {({ formConfig, methods, watch, defaultValue, mode }) => (
                <FormStepper
                    forms={formConfig}
                    watch={watch}
                    mode={mode}
                    methods={methods}
                    defaultValue={defaultValue}
                    showHeader={false}
                />
            )}
        </StandardModalForm>
    );
};
EditTitleMission.propTypes = {
    service: PropTypes.object.isRequired,
    config: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            config: PropTypes.func.isRequired,
        }),
    ).isRequired,
    entity: PropTypes.func.isRequired,
    defaultValue: PropTypes.object,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
};
export default EditTitleMission;
